"use client";

import { c as _c } from "react/compiler-runtime";
import { AuthContext } from "@/components/auth/Auth";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { useSetWavePinnedDrop } from "@/hooks/waves/useSetWavePinnedDrop";
import { MapPinIcon } from "@heroicons/react/24/outline";
import { useContext } from "react";
import type { MouseEvent } from "react";
interface WaveDropActionsSetPinnedDropProps {
  readonly drop: ApiDrop;
  readonly onPinnedDropSet?: (() => void) | undefined;
}
export default function WaveDropActionsSetPinnedDrop(t0) {
  const $ = _c(22);
  const {
    drop,
    onPinnedDropSet
  } = t0;
  const {
    requestAuth,
    setToast
  } = useContext(AuthContext);
  let t1;
  if ($[0] !== onPinnedDropSet || $[1] !== setToast) {
    t1 = () => {
      setToast({
        message: "Pinned drop updated.",
        type: "success"
      });
      onPinnedDropSet?.();
    };
    $[0] = onPinnedDropSet;
    $[1] = setToast;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== setToast) {
    t2 = message => {
      setToast({
        message,
        type: "error"
      });
    };
    $[3] = setToast;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = {
      onSuccess: t1,
      onError: t2
    };
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const {
    isPending,
    pendingDropId,
    setPinnedDrop
  } = useSetWavePinnedDrop(drop.wave.id, t3);
  const isUpdating = isPending && pendingDropId === drop.id;
  let t4;
  if ($[8] !== drop.id || $[9] !== isUpdating || $[10] !== requestAuth || $[11] !== setPinnedDrop) {
    t4 = event => {
      event.stopPropagation();
      if (isUpdating) {
        return;
      }
      (async () => {
        const {
          success
        } = await requestAuth();
        if (!success) {
          return;
        }
        try {
          await setPinnedDrop({
            dropId: drop.id
          });
        } catch {}
      })();
    };
    $[8] = drop.id;
    $[9] = isUpdating;
    $[10] = requestAuth;
    $[11] = setPinnedDrop;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const handleClick = t4;
  let t5;
  if ($[13] !== isUpdating) {
    t5 = isUpdating ? <svg className="tw-h-4 tw-w-4 tw-flex-shrink-0 tw-animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle className="tw-opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" /><path className="tw-opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" /></svg> : <MapPinIcon className="tw-h-4 tw-w-4 tw-flex-shrink-0" />;
    $[13] = isUpdating;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const t6 = isUpdating ? "Updating pinned drop..." : "Set as pinned drop";
  let t7;
  if ($[15] !== t6) {
    t7 = <span className="tw-text-sm tw-font-medium">{t6}</span>;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== handleClick || $[18] !== isUpdating || $[19] !== t5 || $[20] !== t7) {
    t8 = <button type="button" onClick={handleClick} disabled={isUpdating} className="tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-gap-x-3 tw-rounded-lg tw-border-0 tw-bg-transparent tw-px-3 tw-py-2 tw-text-iron-300 tw-transition-colors tw-duration-200 desktop-hover:hover:tw-bg-iron-800">{t5}{t7}</button>;
    $[17] = handleClick;
    $[18] = isUpdating;
    $[19] = t5;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
}